// extracted by mini-css-extract-plugin
export default {"itemCount":"ItemCount_itemCount__3QieL"};